import React, { useState, useEffect } from "react";
import * as Yup from "yup";
import { Row, Col, Table } from "react-bootstrap";
import InputField from "../InputField/InputField";
import CheckboxField from "../CheckboxField/CheckboxField";
import SlectInputField from "../SlectInputField";
import { Formik, Field } from "formik";
import { Link } from "react-router-dom";
import "./CorporateProfile.styles.css";
import ChangePassword from "../ChangePassword";
import Axios from '../../lib/axios/axiosInstance';
import * as AuthVerify from '../../lib/common';
import { Flip, Slide, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { userRegistration , commonPost, commonGet} from "../../services/auth";
import CustomDateTimePicker from '../InputField/CustomDateTimePicker';

const CorporateformSchema = Yup.object().shape({
  fName: Yup.string().min(2).max(25).required("First name is required"),
  lName: Yup.string().min(2).max(25).required("Last name is required"),
  // email: Yup.string().email("Email is invalid").required("Email is required"),
  gender: Yup.string().required(),
  dob: Yup.date().required("Date of birth is required"),
});

const CorporateProfile = () => {
  const [initialValue, setInitialValue] = useState({
    fName: "",
    lName: "",
    gender: "",
    dob: "",
  });

  const [logedInUser, setLogedInUser] = useState(false);
  const [acccountDetails, setacccountDetails] = useState(false);
  const [dob, setDob] = useState(null);

  const getAccountDetails= async (arnum, role,userEmail) => {
    var result=[];
    await Axios.get('/profile/userprofile?username='+userEmail)
    .then(function (response) {
    if(response.data && response.data.profile){
        result.general=response.data.profile;
        setacccountDetails(result);
    }else{
      toast.error('Profile data fetching failed !', {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 3000,
        transition: Flip,
      });
      return false;
    }})
    .catch(function (error) {
      setacccountDetails(false);
    });

  };
  
  useEffect(() => {
    const user=AuthVerify.getUser();
    if(user && user.role){
      getAccountDetails(user.arnum,user.role,user.email);
      setLogedInUser(user.role);
    }
  }, [])

  useEffect(() => {

    setInitialValue({
        fName: acccountDetails.general?.firstname??'',
        lName: acccountDetails.general?.lastname??'',
        gender: acccountDetails.general?.gender=="M"?"Male":"Female",
        dob: acccountDetails.general?.dob??''
    });
    if(acccountDetails.general?.dob)setDob(new Date(acccountDetails.general?.dob))
    setCountryValue(acccountDetails?.country);
    setStateValue(acccountDetails?.state);
    setCityValue(acccountDetails?.city);
  }, [acccountDetails])

  const stateName = [
    { label: "Central", value: "Central" },
    { label: "Illinois", value: "Illinois" },
    { label: "Kansas", value: "Kansas" },
  ];
  const countryName = [
    { label: "Singapore", value: "Singapore" },
    { label: "Australia", value: "Australia" },
    { label: "Austria", value: "Austria" },
    { label: "Argentina", value: "Argentina" },
    { label: "Canada", value: "Canada" },
  ];
  
  const updateFormSubmitHandler = async (values) => {
    var val = {
      profile:{ 
        username: acccountDetails.general.username,
        firstname: values.fName,
        lastname: values.lName,
        arname: acccountDetails.general.arname,
        email: acccountDetails.general.email,
        gender: values.gender.substring(0,1),
        dob: dob,//values.dob,
        addr1: acccountDetails.general.addr1,
        addr2: acccountDetails.general.addr2,
        addr3: acccountDetails.general.addr3,
        country: acccountDetails.general.country,
        state: acccountDetails.general.state,
        city: acccountDetails.general.city,
        postcode: acccountDetails.general.postcode,
        mobile: acccountDetails.general.mobile
      }
    }
    await Axios.post('/profile/userprofile/update',val)
    .then(async (response) =>{
      if (response && response.status == 200 && response.data.profile!=null) {
        toast.success('Profile updated successfully.', {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 4000,
          transition: Slide,
        });
      }
      else {
        toast.error('Something went Wrong!', {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 3000,
          transition: Flip,
        })
      }
    });
  };
  toast.configure();

  
  //--------------------------------
  const [countries, setCountries] = useState([]);
  const [allCountries, setAllCountries] = useState([]);
  const [countryValue, setCountryValue] = useState('');
  const [allStates, setAllStates] = useState([]);
  const [states, setStates] = useState([]);
  const [stateValue, setStateValue] = useState('');
  const [cityValue, setCityValue] = useState('');
  const [allCities, setAllCities] = useState([]);
  const [cities, setCities] = useState([]);
  const [defaultValue, setDefaultValue] = useState(true);

  const getCountries = async () => {
    var allCountries = await commonGet(null,`https://devb2b.bizpoint-intl.com:3082/api/sysvar/countryList`,true);
    var dd=[];
    setAllCountries(allCountries.data.countryList);
    allCountries.data.countryList.forEach(element => {
        dd.push({ label: element.grp.varname, value:  element.grp.varname})
    });
    setCountries(dd);
  };

  async function handleCountryChange(event){
    var result=allCountries.filter(x=>x.grp.varname==event.target.value)[0];
    var dd=[];
    if(result.subgrp.length>0){
      setAllStates(result.subgrp);
      result.subgrp.forEach(element => {
        dd.push({ label: element.grp.varname, value:  element.grp.varname})
     });
    }
    setStates(dd);
    setCities([]);
    setCountryValue(countries.filter(x=>x.value==event.target.value)[0]?.label);
  }

  async function handleStateChange(event){
    var result=allStates.filter(x=>x.grp.varname==event.target.value)[0];
    var dd=[];
    setAllCities(result);
    result.subgrp.forEach(element => {
      dd.push({ label: element.grp.varname, value:  element.grp.varname})
    });
    setCities(dd);
    setStateValue(states.filter(x=>x.value==event.target.value)[0]?.label);
  }

  async function handleCityChange(event){
    setCityValue(cities.filter(x=>x.value==event.target.value)[0]?.label);
  }

  useEffect(async () => {
    getCountries();
  }, [])

  useEffect(async () => {
    if(countryValue && defaultValue && allCountries.length>0){
      handleCountryChange({target:{value:countryValue}});
    }
  }, [allCountries,countryValue])

  useEffect(async () => {
    if(stateValue && defaultValue && allStates.length>0){
      handleStateChange({target:{value:stateValue}});
      setDefaultValue(false);
    }
  }, [allStates,stateValue])
  //--------------------------------

  return (
    <div className="col-main">
      <div className="my-account">
        <div className="page-title">
          <h2 style={{ paddingTop: "12px" }}>Personal Information</h2>
        </div>
        <div className="dashboard">
          <div className="welcome-msg">

            <h4>Manage Personal Information</h4>
            <p>
              Please ensure your details are complete and accurate. Your profile
              details will be used as your default billing information on
              checkout process.
            </p>
          </div>
          <div className="page-content checkout-page">
            <div className="box-border">
              <Formik
                initialValues={initialValue}
                validationSchema={CorporateformSchema}
                onSubmit={(values, { setSubmitting }) => {
                  // console.log(values);
                  updateFormSubmitHandler(values);
                  setSubmitting(false);
                }}
                enableReinitialize
              >
                {({
                  values,
                  errors,
                  touched,
                  handleChange,
                  handleBlur,
                  handleSubmit,
                  isSubmitting,
                  setFieldValue,
                }) => (
                  <form onSubmit={handleSubmit}>
                    <Col xl={12} sm={12} xs={12}>
                        <Row>
                            <Col xl={6} sm={6}>
                              <InputField
                                Name="fName"
                                id="fName"
                                Labels="First Name"
                                Type="text"
                                value={values.fName}
                                onChange={handleChange}
                                isInvalid={!!errors.fName}
                                className={(errors.fName && touched.fName) ? 'is-invalid' : 'form-control'}
                              />
                            </Col>

                            <Col xl={6} sm={6}>
                              <InputField
                                Name="lName"
                                id="lName"
                                Labels="Last Name"
                                Type="text"
                                value={values.lName}
                                onChange={handleChange}
                                isInvalid={!!errors.lName}
                                className={(errors.lName && touched.lName) ? 'is-invalid' : 'form-control'}
                              />
                            </Col>
                          </Row>
                        </Col>
                        <Col xl={12} sm={12} xs={12}>
                        <Row>

                          <Col xl={6} sm={6}>
                            <label>Gender</label>
                            <br />
                            <label style={{ paddingRight: "5px" }}>
                              <input
                                type="radio"
                                name="gender"
                                value="Male"
                                checked={values.gender === "Male"}
                                onChange={handleChange}
                                onBlur={handleBlur}
                              />
                              Male
                            </label>
                            <label>
                              <input
                                type="radio"
                                name="gender"
                                value="Female"
                                checked={values.gender === "Female"}
                                onChange={handleChange}
                                onBlur={handleBlur}
                              />
                              Female
                            </label>
                            {errors.gender && touched.gender ? (
                              <>
                                <span
                                  style={{
                                    color: "red",
                                    paddingLeft: "20px",
                                  }}
                                >
                                  {" ! "} {errors.gender}{" "}
                                </span>
                                <br />
                              </>
                            ) : (
                              ""
                            )}
                          </Col>
                          <Col xl={6} sm={6}>
                              {/* <InputField
                                Name="dob"
                                id="dob"
                                Labels="Date of Birth"
                                Type="date"
                                value={values.dob}
                                onChange={handleChange}
                                isInvalid={!!errors.dob}
                                className={(errors.dob && touched.dob) ? 'is-invalid' : 'form-control'}
                              /> */}
                              <CustomDateTimePicker 
                                  Labels="Date of Birth"
                                  startYear={1970}
                                  value={new Date(dob)}
                                  onChange={(e)=>{handleChange({type:"change",target:{value:e}}); setDob(e);}}
                                  className={(errors.dob && touched.dob ) ? 'is-invalid' : 'form-control'}
                                />
                            </Col>
                        </Row>
                        </Col>
                    <Col xl={12} sm={12} xs={12}>
                      <Row>
                        
                        <Col xl={12} sm={12}>
                          <button type="submit" className="button">
                            Update Profile
                          </button>
                        </Col>
                      </Row>
                    </Col>
                  </form>
                )}
              </Formik>
              <hr />
              {/* <ChangePassword /> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CorporateProfile;
